import React from 'react';

import Dentalbody from './dentalbody';
import './index.scss';

const WebchatPreview = ({message,logo,business_name,assistant_name,actioncolor,brandcolor,usermessage,emailInit, email_capture_message,auth}) => {
    console.log('auth',auth);
    return (
    <div className="brand_preview">
                    <div className="preview-container">
                                <Dentalbody 
                                    message = {message}
                                    logo = {logo}
                                    business_name={business_name}
                                    actioncolor={actioncolor}
                                    brandcolor={brandcolor}
                                    usermessage={usermessage}
                                    emailInit={emailInit}
                                    email_capture_message={ email_capture_message}
                                />
                    </div>
                </div>
  );
};

export default WebchatPreview;
